// import WorkerQueue from '../../worker-queue.ts?worker'
import {
  JobQueueClient,
  JobQueueJobs,
} from '@pogokid/state-machine'
import { JobHubState } from '~m/queue'

export const queueClient = new JobQueueClient<
  JobHubState,
  JobQueueJobs
>({
  async init() {
    console.log('init')
  },
})
